import img from '../../assets/social-ico.webp';

export default function DefaultProfileImage() {
  return (
    <div>
      <img src={img} alt="default profile" />
    </div>
  );
}
